import type { FeedActiveTab } from "@/components/feed/feed-page-client-state";

export const FEED_FOR_YOU_TAB_ENABLED = false;

export const FEED_DEFAULT_ACTIVE_TAB: FeedActiveTab = "live";

export const FEED_TAB_DISPLAY_ORDER: FeedActiveTab[] = FEED_FOR_YOU_TAB_ENABLED
  ? ["for-you", "live", "following", "discover"]
  : ["live", "following", "discover"];

export function isFeedTabVisible(tab: FeedActiveTab, isLoggedIn: boolean): boolean {
  if (tab === "for-you" && !FEED_FOR_YOU_TAB_ENABLED) {
    return false;
  }
  if (tab === "following" && !isLoggedIn) {
    return false;
  }
  return true;
}

export function coerceFeedActiveTab(tab: FeedActiveTab, isLoggedIn: boolean): FeedActiveTab {
  if (isFeedTabVisible(tab, isLoggedIn)) {
    return tab;
  }
  return FEED_DEFAULT_ACTIVE_TAB;
}

export function isFeedSnapStyleTab(tab: FeedActiveTab): boolean {
  return (FEED_FOR_YOU_TAB_ENABLED && tab === "for-you") || tab === "following";
}

export function isFeedScrollableTab(tab: FeedActiveTab): boolean {
  return tab === "live" || tab === "discover";
}
